import { render, staticRenderFns } from "./AceptarInformacion.vue?vue&type=template&id=37d77082&"
import script from "./AceptarInformacion.vue?vue&type=script&lang=ts&"
export * from "./AceptarInformacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('37d77082', component.options)
    } else {
      api.reload('37d77082', component.options)
    }
    module.hot.accept("./AceptarInformacion.vue?vue&type=template&id=37d77082&", function () {
      api.rerender('37d77082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/AceptarInformacion.vue"
export default component.exports